import * as React from 'react';
import { Component, getRandomKey, goToAnchor, I18NString } from '../../Utils';
import {
  IControlSchema,
  createControl,
  ControlErrorListItem,
  IControlError,
} from '../../Controls';
import { IDispatcher, ControlValueDispatcher } from '../extensions/Dispatcher';
import { findIndex, isEmpty, isUndefined, remove } from 'lodash';
import { Panel, Alert } from 'react-bootstrap';
import PanelClone from '../extensions/PanelClone';
import { Dictionary } from '../../../types/Dictionary';

export interface IPanelSchema extends IControlSchema {
  controls: Array<IControlSchema>;
  value: any;
  disabled?: boolean;
  isCreateRows?: boolean;
  description: I18NString;
}

interface IPanelProps {
  schema: IPanelSchema;
  dispatcher?: ControlValueDispatcher;
  values: any;
  errors: Dictionary<IControlError | undefined>;
  visited: Dictionary<boolean>;
  allVisited: boolean;
}

interface State {
  showHelp: boolean;
}

class PanelCtrl extends Component<IPanelProps, State> {
  private checkbox: HTMLInputElement;

  constructor(props) {
    super(props);
    this.state = {
      showHelp: false,
    };
    this.onChange = this.onChange.bind(this);
    this._handleAddRow = this._handleAddRow.bind(this);
    this._handleRemoveRow = this._handleRemoveRow.bind(this);
    this._handlerCopyPanel = this._handlerCopyPanel.bind(this);
  }

  get rows(): any[] {
    return (
      (this.props.schema &&
        this.props.schema.value &&
        this.props.schema.value.rows) ||
      []
    );
  }

  get checked(): boolean {
    return (
      this.props.schema &&
      this.props.schema.value &&
      this.props.schema.value.checked
    );
  }

  onChange() {
    const { dispatcher } = this.props;
    const { id } = this.props.schema;

    let checked = this.checkbox.checked;

    if (!checked) {
      for (let ctrl of this.props.schema.controls) {
        if (
          ctrl.required &&
          !ctrl['disabled'] &&
          ctrl.hasOwnProperty('value') &&
          !isEmpty(ctrl['value'])
        ) {
          checked = true;
        }
      }

      if (!isEmpty(this.rows)) checked = true;
    }

    dispatcher.onBlur(id, { checked, rows: this.rows || [] }, true, undefined);
  }

  componentDidMount() {}

  componentDidUpdate() {}

  _handleAddRow(row: any) {
    const { id } = this.props.schema;
    const rows = [...this.rows, row];

    this.props.dispatcher.onAddValueRefresh(
      id,
      { ...this.props.schema.value, checked: this.checked, rows },
      undefined,
    );
  }

  _handleRemoveRow(key: number, isError: boolean) {
    const { id } = this.props.schema;

    if (isError) {
      let oldrows = [...this.rows];
      const currentRow =
        oldrows[findIndex(oldrows, (obj: any) => obj.key === key)];

      currentRow['isError'] = true;
      this.props.dispatcher.onAddValueRefresh(
        id,
        { ...this.props.schema.value, checked: this.checked, rows: oldrows },
        undefined,
      );
    } else {
      const rows = remove(this.rows, (obj: any) => obj.key !== key);

      this.props.dispatcher.onAddValueRefresh(
        id,
        { ...this.props.schema.value, checked: this.checked, rows },
        undefined,
      );
    }
  }

  createRow() {
    const { controls } = this.props.schema;
    let row = { key: getRandomKey(), controls: [] };
    for (let ctrl of controls) {
      if (ctrl.type.toLocaleUpperCase() !== 'FILE') {
        row.controls.push({ id: `${ctrl.id}_copy_${row.key}`, name: ctrl.id });
      }
    }

    return row;
  }

  _handlerCopyPanel() {
    const { dispatcher, schema } = this.props;
    const currentRow = this.createRow();

    dispatcher.onAddValueRefresh(
      schema.id,
      {
        ...this.props.schema.value,
        checked: this.checked,
        rows: [...this.rows, currentRow],
      },
      undefined,
    );
  }

  render() {
    const controls: Array<React.ReactElement<any>> = [];
    const { dispatcher, schema } = this.props;

    for (let ctrl of this.props.schema.controls) {
      ctrl.disableNumber = this.props.schema.disableNumber;
      if (ctrl.type.toLocaleUpperCase() === 'NUMBER') {
        const d: any = Object.create(dispatcher);
        d.onBlur = (id, value, s, error) =>
          dispatcher.onAddValueRefresh(id, value, error);
        const element = createControl(
          ctrl,
          d,
          this.props.errors,
          this.props.values,
          this.props.visited,
          this.props.allVisited,
        );
        controls.push(React.cloneElement(element, { key: `Panel.${ctrl.id}` }));
      } else {
        const element = createControl(
          ctrl,
          dispatcher,
          this.props.errors,
          this.props.values,
          this.props.visited,
          this.props.allVisited,
        );
        controls.push(React.cloneElement(element, { key: `Panel.${ctrl.id}` }));
      }
    }
    return isUndefined(schema.visible) || schema.visible ? (
      <Panel>
        <Panel.Heading>
          <Panel.Title>
            <div className="row">
              <div className="col-md-11" style={{ display: 'inline-flex' }}>
                {!schema.required && (
                  <input
                    type="checkbox"
                    style={{ marginRight: '10px' }}
                    disabled={this.props.schema.disabled}
                    checked={this.checked || false}
                    onChange={this.onChange}
                    ref={(input) => (this.checkbox = input)}
                  />
                )}
                <span>{`${
                  this.props.schema.disableNumber
                    ? ''
                    : this.props.schema.contentNumb
                }
                                    ${this.tr(this.props.schema.title)}`}</span>
              </div>
              {schema.description && (
                <div className="col-md-1">
                  <button
                    type="button"
                    className="btn btn-default btn-add pull-right btn-circle"
                    onClick={() =>
                      this.setState({ showHelp: !this.state.showHelp })
                    }
                    style={{ marginRight: '10px' }}
                  >
                    <span className="glyphicon glyphicon-question-sign"></span>
                  </button>
                </div>
              )}
            </div>
          </Panel.Title>
        </Panel.Heading>
        <Panel.Body collapsible={schema.required ? false : !this.checked}>
          {controls}
          {!isUndefined(this.props.schema.isCreateRows) &&
            this.props.schema.isCreateRows && (
              <PanelClone
                metadata={schema.controls}
                disabled={this.props.schema.disabled}
                dispatcher={dispatcher}
                errors={this.props.errors}
                allVisited={this.props.allVisited}
                visited={this.props.visited}
                values={this.props.values}
                rows={this.rows}
                onAdd={this._handleAddRow}
                onCopy={this._handlerCopyPanel}
                onRemove={this._handleRemoveRow}
              ></PanelClone>
            )}
        </Panel.Body>
        {this.state.showHelp && (
          <Alert bsStyle="warning">{schema.description.ru}</Alert>
        )}
      </Panel>
    ) : (
      <div></div>
    );
  }
}

export function createPanel(
  schema: IControlSchema,
  dispatcher: IDispatcher = null,
  errors: Dictionary<IControlError | undefined>,
  values: any = null,
  visited: Dictionary<boolean>,
  allVisited: boolean,
): React.ReactElement<any> {
  return (
    <PanelCtrl
      schema={schema as IPanelSchema}
      dispatcher={dispatcher as ControlValueDispatcher}
      values={values}
      errors={errors}
      visited={visited}
      allVisited={allVisited}
    />
  );
}
